document.addEventListener('alpine:init', () => {
  Alpine.data('productCardMedia', (maxIndex = 0) => ({
    active: 0,
    frame: null,
    update() {
      const track = this.$refs.track;
      if (!track) return;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const width = track.clientWidth || 1;
        this.active = Math.max(0, Math.min(Number(maxIndex) || 0, Math.round(track.scrollLeft / width)));
      });
    },
    destroy() {
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }));
});
